<template>
  <b-row>
    <b-col
      v-for="(empresa,index) in totais"
      :key="index"
      cols="2"
    >
      <!-- text-center -->
      <b-card
        body-class="pb-50 grafico-view"
        style="min-height: 90%; position: relative;"
        :class="empresa.hasVencido ? 'centificado-vencido' : ''"
        @click.stop="clicarCard(empresa)"
      >
        <b-row
          class="text-right"
        >
          <b-col
            cols="7"
          >
            <b-avatar
              size="50"
              :variant="empresa.hasVencido ? '' : empresa.iconVariant"
              class="mb-50 mr-50"
            >
              <font-awesome-icon
                :icon="empresa.icon"
                size="2x"
              />
            </b-avatar>
          </b-col>
          <b-col
            cols="5"
          >
            <h4 :class="`font-weight-bolder text-left mt-50 ${ empresa.hasVencido ? 'text-white' : ''}`">
              {{ empresa.valor }}
            </h4>
          </b-col>
        </b-row>
        <b-card-text class="font-small-3 text-center mb-0">
          {{ empresa.titulo }}
        </b-card-text>
        <span
          v-if="empresa.query === 'ProcuracaoVencida' || empresa.query === 'ProcuracaoVencida30Dias'"
          v-b-tooltip.hover
          title="Atualizar procuração"
          style="position: absolute; bottom: 6px; right: 8px;"
          @click.stop="atualizarProcuracao"
        >
          <font-awesome-icon
            :icon="faRefresh"
            :spin="atualizandoProcuracao"
            :class="empresa.hasVencido ? 'text-white' : 'text-primary'"
            style="cursor: pointer;"
          />
        </span>
      </b-card>
    </b-col>
  </b-row>
</template>

<style>
.centificado-vencido {
  background-color: #ea5455;
  color: white;
}
</style>

<script>
import { defineComponent, watch } from '@vue/composition-api'
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faRefresh } from '@fortawesome/free-solid-svg-icons'
import EventBus from '@app/shared/mixins/event-bus/eventBus'
import apiCertificado from '@/app/certificado-digital/shared/services/api'
import useEmpresa from './useEmpresa'

export default defineComponent({
  components: {
    VueApexCharts,
    FontAwesomeIcon,
  },
  data() {
    return {
      faRefresh,
      atualizandoProcuracao: false,
      filtros: {
        empresas: [],
      },
    }
  },
  created() {
    EventBus.$on('atualizacaoProcuracaoFinalizada', () => {
      this.atualizandoProcuracao = false
    })
    EventBus.$on('filtrosDashboardAtualizados', filtro => {
      this.filtros = filtro

      this.dados = useEmpresa(this.filtros, this.router)

      watch(
        () => this.dados.totaisEmpresa,
        newValue => {
          if (newValue && newValue.value) {
            this.totais = newValue.value
          }
        },
        { immediate: true, deep: true },
      )
    })
  },
  setup() {
    const filtro = { empresas: [] }
    const { totaisEmpresa, router } = useEmpresa(filtro)

    return {
      totais: totaisEmpresa,
      router,
    }
  },
  methods: {
    clicarCard(empresa) {
      const filtroRapido = empresa.query || this.filtros.filtroRapido || ''
      const validEmpresas = (this.filtros.empresas && this.filtros.empresas.length > 0 && !this.filtros.empresas.includes(-1) && !this.filtros.empresas.includes('-1'))
        ? this.filtros.empresas
        : undefined
      const queryObj = {
        filtroRapido,
        filtroEmpresa: validEmpresas,
      }
      this.$router.push({ name: empresa.link, query: queryObj })
    },
    atualizarProcuracao() {
      if (this.atualizandoProcuracao) return
      Vue.swal({
        title: 'Atualizar vencimento de procuração',
        html: 'Para iniciar o processo de atualização, informe sua senha de rede.</br></br>',
        input: 'password',
        inputPlaceholder: 'Digite sua senha',
        inputAttributes: {
          autocapitalize: 'off',
          autocorrect: 'off',
          autocomplete: 'new-password',
        },
        icon: 'warning',
        width: '30%',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        customClass: {
          popup: 'swal-m',
          confirmButton: 'btn btn-outline-primary mr-50',
          cancelButton: 'btn btn-outline-warning ',
        },
        buttonsStyling: false,
        preConfirm: senha => {
          if (!senha) {
            Vue.swal.showValidationMessage('A senha é obrigatória')
            return false
          }
          return senha
        },
      }).then(result => {
        if (!result.isConfirmed) return
        this.atualizandoProcuracao = true
        apiCertificado.atualizarVencimentoProcuracao({ senha: result.value })
          .then(() => {
            this.$aviso('Atualização de procuração iniciada. Você receberá uma notificação quando concluir.')
          })
          .catch(err => {
            const msg = err?.response?.data?.message === 'A senha de rede especificada não está correta.'
              ? 'Senha inválida!'
              : 'Não foi possível atualizar as procurações. Tente novamente mais tarde.'
            this.$erro(msg)
            this.atualizandoProcuracao = false
          })
      })
    },
  },
})
</script>
